import {
  Icon,
  Fieldset,
  TextInput,
  Disclosure,
  SimpleSummary,
} from 'corso-admin-ui';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  type ClaimCreateFormInputValues,
  shippingAddressSchema,
} from '~/features/orderLookup/claimCreateSchemas';

export default function ShippingAddressFields() {
  const { register, getValues, formState } =
    useFormContext<ClaimCreateFormInputValues>();
  const defaultValues = getValues('shippingAddress');
  const defaultOpen = useMemo(
    () => !shippingAddressSchema.safeParse(defaultValues).success,
    [defaultValues],
  );

  return (
    <Disclosure
      defaultOpen={defaultOpen}
      renderSummary={() => (
        <SimpleSummary>
          Shipping Address
          {formState.errors.shippingAddress && (
            <Icon icon="error" className="text-red-500" />
          )}
        </SimpleSummary>
      )}
    >
      <Fieldset legend="Shipping Address">
        <div className="space-y-4">
          <TextInput
            id="shipping-address-line1"
            label="Street Address"
            autoComplete="address-line1"
            visuallyRequired
            {...register('shippingAddress.line1')}
            error={formState.errors.shippingAddress?.line1?.message}
          />
          <TextInput
            id="shipping-address-line2"
            label="Street Address Line 2"
            autoComplete="address-line2"
            {...register('shippingAddress.line2')}
            error={formState.errors.shippingAddress?.line2?.message}
          />
          <TextInput
            id="shipping-address-city"
            label="City"
            autoComplete="address-level2"
            visuallyRequired
            {...register('shippingAddress.city')}
            error={formState.errors.shippingAddress?.city?.message}
          />
          <TextInput
            id="shipping-address-state-or-province"
            label="State or Province Code"
            autoComplete="address-level1"
            visuallyRequired
            {...register('shippingAddress.stateOrProvinceCode')}
            error={
              formState.errors.shippingAddress?.stateOrProvinceCode?.message
            }
          />
          <TextInput
            id="shipping-address-postal-code"
            label="Postal Code"
            autoComplete="postal-code"
            visuallyRequired
            {...register('shippingAddress.postalCode')}
            error={formState.errors.shippingAddress?.postalCode?.message}
          />
          <TextInput
            id="shipping-address-country"
            label="Country Code"
            autoComplete="country"
            visuallyRequired
            {...register('shippingAddress.countryCode')}
            error={formState.errors.shippingAddress?.countryCode?.message}
          />
        </div>
      </Fieldset>
    </Disclosure>
  );
}
